var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ieUnSupport)?_c('div',{staticClass:"ieUnSupport"},[_vm._v(" 【重要】2022年2月1日以降、Internet Explorer 11を動作保証対象外といたします　["),_c('a',{on:{"click":_vm.popUpWin}},[_vm._v("詳しくはこちら")]),_vm._v("] ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }